import { render, staticRenderFns } from "./majorForm.vue?vue&type=template&id=7d817241&scoped=true&"
import script from "./majorForm.vue?vue&type=script&lang=js&"
export * from "./majorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d817241",
  null
  
)

export default component.exports